import { useMemo } from 'react';
import { IUserDataToken } from 'utils/types';
import { useQuery } from '@apollo/client';
import { QUERY_ME } from 'graphql/mutations/auth';

export const useUserData = () => {
    const { data: curUserData } = useQuery(QUERY_ME);
    const tenantId = localStorage.getItem('tenant_id');

    const userData: IUserDataToken | null = useMemo(() => {
        if (!curUserData?.me) return null;
        try {
            const decoded = JSON.parse(curUserData.me) as IUserDataToken;
            return decoded;
        } catch (error) {
            console.error('useUserData - Error decoding token:', error);
            return null;
        }
    }, [curUserData]);

    const userId = userData?.userId;
    const tenantIdNumber = tenantId ? Number(tenantId) : null;

    const result = {
        userData,
        userId,
        tenantId: tenantIdNumber,
        isAuthenticated: !!userData && !!tenantId
    };

    return result;
};
